import React, { PureComponent } from 'react';
import { View } from '@dbk/ui-react-utils';
import { Close } from '@dbk/ui-icons';
import Search from '@dbk/ui-search';
import SearchWithoutCircleIcon from '../../../../common/components/icons/search-without-circle';
import { createContainer } from '@dbk-legacy/muster/react';
import debounce from 'lodash/debounce';
import { DBK16_ICON_SIZE } from '../../../../../../dbk-app/src/styles-dbk16/constants';

class SearchFilter extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      searchValue: ''
    }
  }

  clearSearchText = () => {
    this.props.search.callClearFliter();
    this.setState({ searchValue: null });
    this.props.updateSearchText('');
  }

  onChangeTextDelayed = (value) => {
    this.setState({ searchValue: value });
    this.props.updateSearchText(value);
  }

  render() {
    const { i18n: { messages } } = this.props;
    return (
      <View className="margin-top-25">
        <View>
          <Search
            value={this.state.searchValue}
            size="large"
            iconLeft={<SearchWithoutCircleIcon  width={DBK16_ICON_SIZE.DEFAULT} height={DBK16_ICON_SIZE.DEFAULT} />}
            iconRight={Close}
            placeholder={messages['app.search.defaultSearch']}
            onIconClick={() => this.clearSearchText()}
            onChange={debounce(this.onChangeTextDelayed, 800)}
          />
        </View>
      </View>
    );
  }
}

export default createContainer({
  $queries: {
    search: {
      searchData: true,
      cioSearchData1: true,
      callClearFliter: {
        $call: 'clearSearchData',
      },
    },
    i18n: {
      messages: true,
    },
  },
})(SearchFilter);
